import { Plus } from "lucide-react";
import { ModalTrigger } from "./ModalTrigger";

interface NewAccountTriggerProps {
  onAccountCreated?: () => void;
}

export const NewAccountTrigger = ({
  onAccountCreated,
}: NewAccountTriggerProps) => {
  // Store the callback in a way that the modal can access it
  // We'll use a custom event or context instead of navigation state
  if (onAccountCreated) {
    // Store the callback globally so the modal can access it
    (window as any).__accountCreatedCallback = onAccountCreated;
  }

  return (
    <ModalTrigger
      modalPath="/modals/account/create"
      className="bg-lime text-foreground cursor-pointer hover:text-background"
    >
      <Plus className="w-4 h-4" />
      New Account
    </ModalTrigger>
  );
};
